import * as Models from ".";
export interface IProductModel {
        code: string;
        name: string;
    }

export class ProductModel implements IProductModel {
        code: string;
        name: string;

        constructor(name: string, code: string) {
            this.name = name;
            this.code = code;
        }
    }